import { RESET_STATE } from 'store/global/actions';

import { PRICING_CALENDAR_ACTION_TYPE } from '../actions';

const initialState = {
  current: { data: null, isLoading: false, hasError: false },
  versions: { data: [], isLoading: false, hasError: false },
  save: { isSaving: false, errorMessage: null },
};

const pricingCalendarReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case PRICING_CALENDAR_ACTION_TYPE.SET_LOADING:
      return {
        ...state,
        current: {
          ...state.current,
          isLoading: payload,
          hasError: payload ? false : state.current.hasError,
        },
      };

    case PRICING_CALENDAR_ACTION_TYPE.SET_ERROR:
      return { ...state, current: { ...state.current, isLoading: false, hasError: true } };

    case PRICING_CALENDAR_ACTION_TYPE.GET_PRICING_CALENDAR:
      return { ...state, current: { data: payload ?? null, isLoading: false, hasError: false } };

    case PRICING_CALENDAR_ACTION_TYPE.SET_VERSIONS_LOADING:
      return {
        ...state,
        versions: {
          ...state.versions,
          isLoading: payload,
          hasError: payload ? false : state.versions.hasError,
        },
      };

    case PRICING_CALENDAR_ACTION_TYPE.SET_VERSIONS_ERROR:
      return { ...state, versions: { ...state.versions, isLoading: false, hasError: true } };

    case PRICING_CALENDAR_ACTION_TYPE.GET_PRICING_CALENDAR_VERSIONS:
      return { ...state, versions: { data: payload ?? [], isLoading: false, hasError: false } };

    case PRICING_CALENDAR_ACTION_TYPE.SET_SAVING:
      return { ...state, save: { isSaving: payload, errorMessage: null } };

    case PRICING_CALENDAR_ACTION_TYPE.SET_SAVE_ERROR:
      return { ...state, save: { isSaving: false, errorMessage: payload ?? null } };

    case PRICING_CALENDAR_ACTION_TYPE.UPSERT_PRICING_CALENDAR:
      return {
        ...state,
        current: { data: payload, isLoading: false, hasError: false },
        versions: { ...state.versions, data: [payload, ...state.versions.data] },
        save: { isSaving: false, errorMessage: null },
      };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default pricingCalendarReducer;
